import InputAdornment from '@material-ui/core/InputAdornment';

/** @deprecated Exporting the InputAdornment component from the @material-ui/core/InputAdornment module. */
export default InputAdornment;
